import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '@app/core/services/data.service';
import {
    ChatConversationDto,
    ChatCreateConversationRequest,
    ChatMessageDto,
    ChatMessagesPageDto,
    ChatSendMessageRequest,
    SimpleUserDto
} from '@app/core/models/chat/chat.models';

@Injectable({ providedIn: 'root' })
export class ChatApiService {
    constructor(private dataService: DataService) { }

    private withSwBypass(service: string): string {
        const separator = service.includes('?') ? '&' : '?';
        return `${service}${separator}ngsw-bypass=true`;
    }

    getConversations(): Observable<ChatConversationDto[]> {
        return this.dataService.getV2<ChatConversationDto[]>(this.withSwBypass('chat/conversations'));
    }

    createConversation(request: ChatCreateConversationRequest): Observable<ChatConversationDto> {
        return this.dataService.postV2<ChatConversationDto>('chat/conversations', request);
    }

    getMessages(conversationId: string, skip = 0, take = 20): Observable<ChatMessagesPageDto> {
        const service = `chat/conversations/${conversationId}/messages?skip=${skip}&take=${take}`;
        return this.dataService.getV2<ChatMessagesPageDto>(this.withSwBypass(service));
    }

    sendMessage(request: ChatSendMessageRequest): Observable<ChatMessageDto> {
        return this.dataService.postV2<ChatMessageDto>('chat/messages', request);
    }

    markRead(conversationId: string): Observable<void> {
        return this.dataService.postV2<void>(`chat/conversations/${conversationId}/read`, {});
    }

    deleteConversation(conversationId: string): Observable<void> {
        return this.dataService.deleteV2<void>(`chat/conversations/${conversationId}`);
    }

    getUsersSimple(filter?: string): Observable<SimpleUserDto[]> {
        const search = filter ? `?filter=${encodeURIComponent(filter)}` : '';
        return this.dataService.getV2<SimpleUserDto[]>(this.withSwBypass(`users/simple${search}`));
    }
}
